/*
  VBRNTT testimonials, staggered layout (sections/vbrntt-testimonials.liquid):
  on phones only the first few quotes show (data-initial), with one button to
  reveal the rest; on wider screens every quote shows. The extras carry
  data-extra from the server. Without JavaScript nothing is hidden.
*/
if (!customElements.get('vbrntt-testimonials')) {
  customElements.define(
    'vbrntt-testimonials',
    class VbrnttTestimonials extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-more]');
        if (!this.button || !this.querySelector('[data-extra]')) return;
        this.classList.add('is-capped');
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          const first = this.querySelector('[data-extra]');
          this.classList.remove('is-capped');
          this.button.hidden = true;
          // Move focus to the first quote that just appeared, so keyboard and
          // screen reader users land on the new content.
          if (first) {
            first.setAttribute('tabindex', '-1');
            first.focus();
          }
        });
      }
    }
  );
}
